<template>
    <div
        class="
            c-entity__status c-entity__status-tracked
            flex-container flex-justify-space-between
        "
    >
        <span>This account <strong>IS</strong> tracked.</span>
        <span>
            <a @click.prevent="toggle">Turn off tracking for this Account</a>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        account: Object,
    },
    data: () => {
        return {};
    },
    methods: {
        toggle() {
            this.account.is_tracked = false;
        },
    },
};
</script>
